import { html, LitElement, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { getBulletColorForScore } from '../../../common/utils';
import { getTextForScore } from '../../../common/customRenderers';
import { FontSizes } from '../../../../types/common/types';
import { WEB_COMPONENT_GZ_RM_SEVERITY } from '../../../../webcomponents.constants';

@customElement(WEB_COMPONENT_GZ_RM_SEVERITY)
export class GzRmSeverity extends LitElement {
  @property({ type: Number, attribute: true, reflect: true })
  score?: number = undefined;

  @property({ type: Boolean, attribute: true, reflect: true })
  reverse = false;

  /**
   * See noHighlight attribute of gz-text for more info.
   */
  @property({ type: Boolean, attribute: true, reflect: true })
  noHighlight = false;

  protected render(): TemplateResult {
    const severity = this.computeSeverity(this.score);
    const text = severity.label && this.score !== undefined ? `${severity.label} (${this.score}%)` : '--';

    return html`
      <gz-bullet .color="${severity.color}" .reverse="${this.reverse}">
        <span>
          <gz-text exportparts="highlightable" ?noHighlight="${this.noHighlight}" fontSize="${FontSizes.HEADING_6}"> ${text} </gz-text>
        </span>
      </gz-bullet>
    `;
  }

  private computeSeverity(score: number | undefined): Severity {
    if (score === undefined) {
      return {
        color: 'var(--grey-layout-202-disabled-icons)',
      };
    }

    return {
      label: getTextForScore(score),
      color: getBulletColorForScore(score),
    };
  }
}

interface Severity {
  label?: string;
  color: string;
}

declare global {
  interface HTMLElementTagNameMap {
    [WEB_COMPONENT_GZ_RM_SEVERITY]: GzRmSeverity;
  }
}
